import React, {useEffect, useState} from "react";
import DataTable from 'react-data-table-component';
import {getReQuote, postReQuote} from "../../services/cotizador-service";
import {Link, useParams} from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";

export default function Requoter() {

    const {movementId} = useParams();
    const [tableRequoter, setTableRequoter] = useState([]);
    const [tableRequoteDone, setTableRequoteDone] = useState([]);
    const [pending, setPending] = useState(true);
    const [requoteDone, setRequoteDone] = useState(false);

    //When component starts...
    useEffect(() => {
        //Request sending movId
        getReQuote(movementId).then(data => {
            //Pushing response into an array so we can show the data.
            let toArray = [];
            toArray.push(data);
            setTableRequoter(toArray);
            setPending(false); //Stop animation
        }).then(() => Swal.close()).catch(() => {
            Swal.fire({
                title: 'Ocurrió un error',
                text: `No se pudo recotizar`,
                icon: 'error',
                iconColor: 'var(--skrSecondary)',
                backdrop: `rgba(71, 10, 104, .75)`,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonColor: 'var(--skrSecondary)',
                cancelButtonText: 'Ok'
            });
        });
    }, []);

    const columnsRequote = [
        {
            name: 'Compañía',
            selector: row => row.insuranceCompany,
            sortable: false,
            wrap: true,
            conditionalCellStyles: [
                {
                    when: row => row.insuranceCompanyId === 2,
                    style: {
                        color: '#00973d',
                        fontSize: '15px',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.insuranceCompanyId === 1,
                    style: {
                        color: '#0091a9',
                        fontSize: '15px',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.insuranceCompanyId === 3,
                    style: {
                        color: '#bb0003',
                        fontSize: '15px',
                        fontWeight: 600,
                    }
                },
                {
                    when: row => row.insuranceCompanyId === 4,
                    style: {
                        color: '#2dc2d7', //fb6c0f
                        fontSize: '15px',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.insuranceCompanyId === 7,
                    style: {
                        color: '#0f2d74',
                        fontSize: '15px',
                        fontWeight: 600,
                    },
                },
            ]
        },
        {
            name: 'No. Cotización',
            selector: row => row.quoteNumber,
            sortable: false,
            wrap: true,
        },
        {
            name: 'Año modelo',
            selector: row => row.modelYear,
            sortable: false,
            wrap: true,
        },
        {
            name: 'Vehículo',
            selector: row => row.vehicle,
            sortable: false,
            wrap: true,
        },
        {
            name: 'Fecha de inicio',
            selector: row => moment(row.startDate).format('DD/MM/yyyy'),
            sortable: false,
            wrap: true,
        },
        {
            name: 'Fecha de termino',
            selector: row => moment(row.endDate).format('DD/MM/yyyy'),
            sortable: false,
            wrap: true,
        },
        {
            name: 'Valor Factura',
            selector: row => {
                if (row.insuredAmount == 0) {
                    return 'Valor Comercial'
                } else {
                    return '$' + row.insuredAmount.toLocaleString('en', {maximumFractionDigits: 2})
                }
            },
            sortable: false,
            omit: true,
            wrap: true,
        },
        {
            name: 'Total',
            selector: row => <span
                className="fw-bold">${row.totalPremium.toLocaleString('en', {maximumFractionDigits: 2})}</span>,
            sortable: false,
            wrap: true,
        },
        {
            name: 'MovementId',
            selector: row => row.movementId,
            omit: true,
            wrap: true,
        },
        {
            name: 'Emitir',
            selector: row =>
                <span>
                    <Link to="/emision">
                        <button className="btn btn-skr-secondary btn-sm">Emitir</button>
                    </Link>
                </span>,
            sortable: false,
            wrap: true,
            omit: true
        },
        {
            name: 'Acciones...',
            selector: row =>
                <span>
                        <button className="btn btn-skr-secondary btn-sm" onClick={() => {
                            Swal.fire({
                                title: 'Recotizando...',
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: () => {
                                    Swal.showLoading();
                                    return postReQuote(movementId).then(data => {
                                        let toArray = [];
                                        toArray.push(data);
                                        setTableRequoteDone(toArray);
                                    }).then(() => {
                                        setRequoteDone(true);
                                    }).then(() => Swal.close()).catch(error => {
                                        Swal.fire({
                                            title: 'Ocurrió un error',
                                            text: `No se pudo recotizar`,
                                            icon: 'error',
                                            iconColor: 'var(--skrSecondary)',
                                            backdrop: `rgba(71, 10, 104, .75)`,
                                            showCancelButton: true,
                                            showConfirmButton: false,
                                            cancelButtonColor: 'var(--skrSecondary)',
                                            cancelButtonText: 'Ok'
                                        });
                                    })
                                }
                            })
                        }} disabled={tableRequoteDone.length > 0}><i className="bi-arrow-repeat"></i> Recotizar</button>
                </span>,
            sortable: false,
            wrap: true,
            omit: false
        }];

    const columnsRequoteDone = [
        {
            name: 'Compañía',
            selector: row => row.insuranceCompany,
            sortable: false,
            wrap: true,
            conditionalCellStyles: [
                {
                    when: row => row.insuranceCompanyId === 2,
                    style: {
                        color: '#00973d',
                        fontSize: '15px',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.insuranceCompanyId === 1,
                    style: {
                        color: '#0091a9',
                        fontSize: '15px',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.insuranceCompanyId === 3,
                    style: {
                        color: '#bb0003',
                        fontSize: '15px',
                        fontWeight: 600,
                    },
                },
            ]
        },
        {
            name: 'No. Cotización',
            selector: row => row.quoteNumber,
            sortable: false,
            wrap: true,
        },
        {
            name: 'Año modelo',
            selector: row => row.modelYear,
            sortable: false,
            wrap: true,
        },
        {
            name: 'Vehículo',
            selector: row => row.vehicle,
            sortable: false,
            wrap: true,
        },
        {
            name: 'Fecha de inicio',
            selector: row => moment(row.startDate).format('DD/MM/yyyy'),
            sortable: false,
            wrap: true,
        },
        {
            name: 'Fecha de termino',
            selector: row => moment(row.endDate).format('DD/MM/yyyy'),
            sortable: false,
            wrap: true,
        },
        {
            name: 'Valor Factura',
            selector: row => {
                if (row.insuredAmount == 0) {
                    return 'Valor Comercial'
                } else {
                    return '$' + row.insuredAmount.toLocaleString('en', {maximumFractionDigits: 2})
                }
            },
            sortable: false,
            omit: true,
            wrap: true,
        },
        {
            name: 'Total',
            selector: row => <span
                className="fw-bold">${row.totalPremium.toLocaleString('en', {maximumFractionDigits: 2})}</span>,
            sortable: false,
            wrap: true,
        },
        {
            name: 'MovementId',
            selector: row => row.movementId,
            omit: true,
            wrap: true,
        },
        {
            name: 'Emitir',
            selector: row =>
                <span>
                    <Link to="/emision">
                        <button className="btn btn-skr-secondary btn-sm">Emitir</button>
                    </Link>
                </span>,
            sortable: false,
            wrap: true,
            omit: true
        }];

    return (
        <div>
            <div className="skr-panel">
                <h1 className="mx-2">Recuperar Cotización <i className="bi-arrow-repeat float-end"></i></h1>
            </div>

            <div>
                <div className="container-fluid w-auto border mt-5">
                    <div className="row border-bottom">
                        <div className="col">
                            <DataTable
                                columns={columnsRequote}
                                data={tableRequoter}
                                pagination={false}
                                dense={true}
                                responsive={true}
                                compact={true}
                                progressPending={pending}
                                styled
                                striped/>
                        </div>
                    </div>
                    {requoteDone ?
                        <div className="row">
                            <div className="col text-center">
                                <h4 className="mt-4">Cotización Exitosa:</h4>
                                <DataTable
                                    columns={columnsRequoteDone}
                                    data={tableRequoteDone}
                                    pagination={false}
                                    dense={true}
                                    responsive={true}
                                    compact={true}
                                    styled
                                    striped/>
                            </div>
                        </div> : null}
                </div>
            </div>

        </div>
    );
}